// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.badge[data-v-efa0c778]
	{
		display: inline-block;
		font-weight: bold;
		background-color: #FFFFFF;
		border: 1px solid rgba(0,0,0,0.5);
		border-radius: 3px;
		padding: 3px 8px;
}
.badge.Upcoming[data-v-efa0c778]
		{
			background-color: rgb(255 207 180);
			border-color: rgb(200 96 0);
}
.badge.Staging[data-v-efa0c778]
		{
			background-color: rgb(255 245 180);
			border-color: rgb(200 165 0);
}
.badge.Live[data-v-efa0c778]
		{
			background-color: rgb(132 255 132);
			border-color: rgb(0 149 0);
}
.badge.Inactive[data-v-efa0c778]
		{
			background-color: rgb(151 216 255);
			border-color: rgb(19 81 119);
}
.badge.disabled[data-v-efa0c778]
		{
			font-weight: normal;
			background-color: #FFFFFF;
			border-color: rgba(0,0,0,0.5);
			opacity: 0.38;
}
.badge.compact[data-v-efa0c778]
		{
			font-size: 11px;
			font-weight: normal;
			vertical-align: bottom;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/CmsLifecycleStateBadge.vue"],"names":[],"mappings":";AAsCC;;EAEC,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AACjB;AAEC;;GAEC,kCAAkC;GAClC,2BAA2B;AAC5B;AAEA;;GAEC,kCAAkC;GAClC,4BAA4B;AAC7B;AAEA;;GAEC,kCAAkC;GAClC,0BAA0B;AAC3B;AAEA;;GAEC,kCAAkC;GAClC,4BAA4B;AAC7B;AAEA;;GAEC,mBAAmB;GACnB,yBAAyB;GACzB,6BAA6B;GAC7B,aAAa;AACd;AAEA;;GAEC,eAAe;GACf,mBAAmB;GACnB,sBAAsB;AACvB","sourcesContent":["<template>\r\n\t<div class=\"badge\" :class=\"badgeDynClasses\">{{text}}</div>\r\n</template>\r\n\r\n<script>\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\ttext: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\trequired: true\r\n\t\t\t},\r\n\t\t\tdisabled: {\r\n\t\t\t\ttype: Boolean,\r\n\t\t\t\tdefault: false\r\n\t\t\t},\r\n\t\t\tcompact: {\r\n\t\t\t\ttype: Boolean,\r\n\t\t\t\tdefault: false\r\n\t\t\t}\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tbadgeDynClasses()\r\n\t\t\t{\r\n\t\t\t\tlet classes = [];\r\n\t\t\t\tclasses.push(this.text);\r\n\t\t\t\tif (this.disabled)\r\n\t\t\t\t\tclasses.push(\"disabled\");\r\n\t\t\t\tif (this.compact)\r\n\t\t\t\t\tclasses.push(\"compact\");\r\n\t\t\t\treturn classes;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.badge\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tfont-weight: bold;\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tborder: 1px solid rgba(0,0,0,0.5);\r\n\t\tborder-radius: 3px;\r\n\t\tpadding: 3px 8px;\r\n\t}\r\n\r\n\t\t.badge.Upcoming\r\n\t\t{\r\n\t\t\tbackground-color: rgb(255 207 180);\r\n\t\t\tborder-color: rgb(200 96 0);\r\n\t\t}\r\n\r\n\t\t.badge.Staging\r\n\t\t{\r\n\t\t\tbackground-color: rgb(255 245 180);\r\n\t\t\tborder-color: rgb(200 165 0);\r\n\t\t}\r\n\r\n\t\t.badge.Live\r\n\t\t{\r\n\t\t\tbackground-color: rgb(132 255 132);\r\n\t\t\tborder-color: rgb(0 149 0);\r\n\t\t}\r\n\r\n\t\t.badge.Inactive\r\n\t\t{\r\n\t\t\tbackground-color: rgb(151 216 255);\r\n\t\t\tborder-color: rgb(19 81 119);\r\n\t\t}\r\n\r\n\t\t.badge.disabled\r\n\t\t{\r\n\t\t\tfont-weight: normal;\r\n\t\t\tbackground-color: #FFFFFF;\r\n\t\t\tborder-color: rgba(0,0,0,0.5);\r\n\t\t\topacity: 0.38;\r\n\t\t}\r\n\r\n\t\t.badge.compact\r\n\t\t{\r\n\t\t\tfont-size: 11px;\r\n\t\t\tfont-weight: normal;\r\n\t\t\tvertical-align: bottom;\r\n\t\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
